export default __webpack_public_path__ + "static/media/gift-aid-payment.daaf7900.svg";